import { Box, Button, Checkbox, Dialog, DialogContent, DialogTitle, Divider, Grid, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { bodyGridStyle, buttonBoxStyle, chapterCodeTextStyle, descriptionBoxStyle, descriptionTextStyle, headerGridContainerStyle, headerTextStyle, idValueBoxStyle, imageBoxStyle, imgStyle, inputBoxStyle, titleStyle } from './updateWORKerDetails_css'
import CustomTextField from '../../CustomTextField'
import { CheckBox, PhotoFilterRounded } from '@mui/icons-material'
import { buttonStyle, ButtonStyle, errorStyleText } from '../../formStyle'
import { updateWORKerDetails } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import { darkGrey, green, mediumGrey } from '../../../assets/colors'
import { useNavigate } from 'react-router-dom'
import Loader from '../../Loader'

const UpdateWORKerDetails = (props) => {

  const [idCode, setIdCode] = useState(null)
  const [photo, setPhoto] = useState(null)
  const [preview, setPreview] = useState(null);
  const [idInputBoxDisabled, setIdInputBoxDisabled] = useState(false)
  const [isMissing, setisMissing] = useState(false)
  const [idError, setIdError] = useState(null)

  const [idSectionError, setIdSectionError] = useState(null)
  const [imageError, setImageError] = useState(null)
  const [generateError, setGenerateError] = useState(null)
  const [loader, setLoader] = useState(false)

  const fileInputRef = useRef()
  const navigate = useNavigate()

  const updateIdCode = (value) => {
    if( value.length < 4 && (/^\d+$/.test(value) || value === '')){
      setIdCode(value)
      setIdError(null)
    } else if(!/^\d+$/.test(value)){
      setIdError('Id can only have digits.')
    } else {
      setIdError('Id cannot be more than 3 digits.')
    }
  }

  const updatePhoto = (event) => {
    const file = event.target.files[0];
    setPhoto(event.target.files[0])
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result)
    }
    reader.readAsDataURL(file)
  }

  function validateGenerate(){
    let isValid = true
    setIdSectionError(null)
    setImageError(null)
    if( !idCode && !isMissing ){
      isValid = false
      setIdSectionError(`Enter your ID or check the box if it's unavailable or forgotten.`)
    }

    if( !photo){
      isValid = false
      setImageError('Upload your Image.')
    }
    return isValid
  }

  const handleGenerate = async () => {
    try{
      setLoader(true)
      let result = await validateGenerate()
      if( result && localStorage.getItem('contact')){
        const formData = new FormData()
        formData.append('image', photo)
        formData.append('contactNumber', props?.contactNumber ? props?.contactNumber : localStorage.getItem('contact'))
        formData.append('id', idCode)
        if( !idCode){
          formData.append('isMissing', isMissing)
        } else {
          formData.append('isMissing', 'false')
        }
        
        formData.append('chapterCode', props.chapterCode)
        formData.append('gender', props.gender)
        let options = {
          url: updateWORKerDetails,
          method: 'POST',
          formData: formData,
          headers: {headers: {
            // 'Content-Type': 'multipart/form-data',
            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : ''
          }}
        }
        console.log("formData: ", options.formData)
        HttpService(options).then(() => {
          setLoader(false)
          props.updateWORKerDetailsDialogStatusFunc(false)
        }).catch(err => {
          setLoader(false)
          if (err?.status === 403) {
            localStorage.clear();
            // setLoadingTableData(false);
            navigate("/signUp");
          } else {
            console.log("Err:", err)
            setGenerateError(err?.response?.data?.message)
            // setLoadingTableData(false);
          }

        })

      } else {
        setLoader(false)
        if(!localStorage.getItem('contact')){
					navigate('/signUp')
				}
      }
      
    } catch(err){
      setLoader(false)
      setGenerateError('Error in Generating Membership Card.Please Contact Support.')
      console.log("Error In generating membership card: ", err)

    }
  }

  useEffect(() => {
    setIdCode(props?.id ? props.id : null)
    setPhoto(null)
    setPreview(null)
    setIdInputBoxDisabled(false)
    setIdError(null)
    setIdSectionError(null)
    setImageError(null)
    setGenerateError(null)
  }, [props.wORKerDetailsDialogStatus])
  return (
    <>
    <Dialog maxWidth='sm' fullWidth open={props.wORKerDetailsDialogStatus} onClose={() => {props.updateWORKerDetailsDialogStatusFunc()}}>
        <DialogTitle style={titleStyle}>
            Update WORKer Details
        </DialogTitle>
        <DialogContent>
            {loader && 
              <>
                <Loader></Loader>
              </>
            }
            <Grid container spacing={1}>
              <Grid item xs={12} sm={8} > 
                <Box style={{ padding: '1rem 0.1rem 0.5rem 0.1rem'}}>
                <Grid container spacing = {1} style={bodyGridStyle}>
                  <Grid item xs = {0.7} sm = {0.7}>
                    <Box style={{...idValueBoxStyle, height: '1.9rem'}}>
                      <Typography style={{...chapterCodeTextStyle}}>Id:</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs = {10} sm = {10}>
                    <Box style={{...idValueBoxStyle, border: '1pxsolid', pointerEvents: idInputBoxDisabled ? 'none' : 'auto'}}>
                      <Typography style={{...chapterCodeTextStyle, fontWeight: 400, color: green, fontSize: '0.85rem', padding: '0rem 0rem 0rem 0.5rem'}}>{props.chapterCode}</Typography>
                      <CustomTextField value={idCode} setFunc = {updateIdCode} width='8rem'></CustomTextField>
                    </Box>
                    <Box>
                      <Typography style={errorStyleText}>{idError}</Typography>
                    </Box>
                  </Grid>
                </Grid>
                {!props.id  && 
                <>
                  <Divider sx={{color: darkGrey}}>OR</Divider>
                  <Box style={descriptionBoxStyle}>
                    <Box>
                      <Checkbox sx={{padding: '0.1rem 0rem 0.1rem 0rem'}}
                        onClick={() => {
                          setisMissing(!isMissing)
                          setIdInputBoxDisabled(!idInputBoxDisabled)
                          setIdCode(null)
                        }}
                      ></Checkbox>
                    </Box>
                      <Typography style={descriptionTextStyle}>
                        Id not available or forgotten.
                      </Typography>
                  </Box>
                </>
                }
                {props.photoStatus === 'rejected' && 
                <Typography style={errorStyleText}> Your ID card photo has been rejected—please upload a clear, passport-size photo with a plain background.</Typography>
                }
                </Box>
                <Box>
                  <Typography style={errorStyleText}>{idSectionError}</Typography>

                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '0.7rem 0.2rem 0.2rem 0.2rem'}}>
                  <Box style={imageBoxStyle}>
                    <img
                      style={imgStyle} 
                      src={preview ? preview : require('../../../assets/images/manager.png')}
                    >

                      </img>

                  </Box>
                  <Box style={inputBoxStyle}>
                    <input ref={fileInputRef} type='file' accept='image/*' style={{display: 'none'}} onChange={updatePhoto}></input>
                    <Button 
                      style={{...buttonStyle, fontSize: '0.7rem', padding: '0.1rem 0.3rem 0.1rem 0.3rem'}} sx={{textTransform: "capitalize"}}
                      onClick={() => {
                        fileInputRef.current.click()
                      }}
                    >Choose Image</Button>
                  </Box>
                  <Box>
                    <Typography style={errorStyleText}>{imageError}</Typography>
                  </Box>

                </Box>
              </Grid>
            </Grid>
          {/* </Box> */}

            
            {/* <CheckBox></CheckBox>
            <Typography> or Is Photo Missing?</Typography> */}
            <Box style={{display: 'flex', justifyContent: 'center'}}>
              <Typography style={errorStyleText}>{generateError}</Typography>
            </Box>
            <Box style={buttonBoxStyle}>
              <Button style={{...ButtonStyle, padding: '0.1rem 0.4rem 0.1rem 0.4rem'}}
              onClick={()=> handleGenerate()}
              >Generate</Button>
            </Box>
            

        </DialogContent>

    </Dialog>
    </>
  )
}

export default UpdateWORKerDetails
